import { supabase } from '@/lib/supabase';

export type LivePlatform = 'youtube' | 'tiktok' | 'instagram' | 'linkedin' | 'google';

export interface LiveStream {
  id: string;
  owner_id: string;
  title: string;
  host: string;
  handle: string | null;
  category: string;
  platform: LivePlatform;
  status: 'live' | 'upcoming';
  scheduled_at: string | null;
  link_url: string;
  products: string | null;
  created_at: string;
}

export interface ProposeLiveInput {
  title: string;
  host: string;
  handle: string;
  category: string;
  platform: LivePlatform;
  scheduledAt: string;
  linkUrl: string;
  products: string;
}

export const LIVE_PLATFORMS: { value: LivePlatform; label: string; icon: string }[] = [
  { value: 'youtube', label: 'YouTube', icon: 'ri-youtube-fill' },
  { value: 'tiktok', label: 'TikTok', icon: 'ri-tiktok-fill' },
  { value: 'instagram', label: 'Instagram', icon: 'ri-instagram-fill' },
  { value: 'linkedin', label: 'LinkedIn', icon: 'ri-linkedin-fill' },
  { value: 'google', label: 'Google Drive / Meet', icon: 'ri-google-fill' },
];

export function validateLiveLink(platform: LivePlatform, url: string): boolean {
  const u = url.trim().toLowerCase();
  if (!u) return false;
  switch (platform) {
    case 'youtube':
      return u.includes('youtube.com') || u.includes('youtu.be');
    case 'tiktok':
      return u.includes('tiktok.com');
    case 'instagram':
      return u.includes('instagram.com');
    case 'linkedin':
      return u.includes('linkedin.com');
    case 'google':
      return u.includes('drive.google.com') || u.includes('meet.google.com');
    default:
      return false;
  }
}

export async function fetchLiveStreams(): Promise<LiveStream[]> {
  const { data, error } = await supabase
    .from('live_streams')
    .select('*')
    .order('scheduled_at', { ascending: true });
  if (error) throw error;
  return (data as LiveStream[]) || [];
}

export async function proposeLive(input: ProposeLiveInput): Promise<LiveStream> {
  const { data: sessionData } = await supabase.auth.getSession();
  const user = sessionData?.session?.user;
  if (!user) throw new Error('Vous devez être connecté pour proposer un live.');

  const { data, error } = await supabase
    .from('live_streams')
    .insert({
      owner_id: user.id,
      title: input.title,
      host: input.host,
      handle: input.handle || null,
      category: input.category,
      platform: input.platform,
      status: 'upcoming',
      scheduled_at: input.scheduledAt,
      link_url: input.linkUrl,
      products: input.products.trim() || null,
    })
    .select()
    .single();
  if (error) throw error;
  return data as LiveStream;
}